import { post, postMultipart } from "../../api/HttpClient.js";
import { BASE_URL, Support_url, RemoveAccount_url } from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";
import { getGuId } from "../../utils/SecurityService.js";

// Need help? / Support form.
// Sent as multipart/form-data because of the JPG attachments (up to 3).
// Field names use PascalCase to match the v5 backend contract; Attachment[] mirrors Android.
export const Support_api = ({ Title, Body, files = [] }) => {
    const formData = new FormData();
    formData.append("GuId", getGuId());
    formData.append("Title", Title);
    formData.append("Body", Body);
    formData.append("Language", AppConstant.Language);
    formData.append("AppVersion", AppConstant.AppVersion);
    formData.append("OsVersion", AppConstant.OsVersion);
    formData.append("DeviceId", AppConstant.DeviceID);
    formData.append("ManufactureModel", AppConstant.ManufactureModel);
    files.forEach((file) => formData.append("Attachment[]", file, file.name));

    return postMultipart({
        url: `${BASE_URL}${Support_url}`,
        formData,
    });
};

// Remove account request ("Remove my account").
// PascalCase fields match the v5 backend contract; device/version values come
// from AppConstant. ClientId + GuId are required; RequestFrom + device/version
// fields are optional error-log metadata. The Bearer token is added by `post()`.
export const RemoveAccount_api = () => {
    return post({
        url: `${BASE_URL}${RemoveAccount_url}`,
        params: {
            ClientId: AppConstant.DEFAULT_CLIENT_ID,
            GuId: getGuId(),
            RequestFrom: AppConstant.React_hardcode,
            DeviceId: AppConstant.DeviceID,
            ManufactureModel: AppConstant.ManufactureModel,
            OsVersion: AppConstant.OsVersion,
            AppVersion: AppConstant.AppVersion,
            Language: AppConstant.Language,
        },
    });
};
